import { Stack } from "@fluentui/react";
import { DEFAULT_USE_CASE_NAME } from "../../utils/constants";
import CardGroup from "../Cards/CardGroup";

import EuCo from "../../assets/EuCo.svg";
import styles from "./ChatLander.module.css";
import { CHAT_INCENTIVE, CHAT_NAME, LOADING_TEXT } from "./constants";

interface ChatLanderProps {
  visualUseCase: string;
  isAssistantAPILoading: boolean;
  dgName: string;
  handleSelectUseCase: (
    title: string,
    key: string,
    confirmationMessage?: string,
  ) => void;
}

const ChatLander = ({
  visualUseCase,
  isAssistantAPILoading,
  dgName,
  handleSelectUseCase,
}: ChatLanderProps) => {
  const displayName = `${dgName} ${CHAT_NAME}`;
  return (
    <Stack className={styles.chatEmptyState}>
      <>
        <h1 className={styles.chatEmptyStateTitle}>{displayName}</h1>
        <h2 className={styles.chatEmptyStateSubtitle}>{CHAT_INCENTIVE}</h2>
      </>
      {visualUseCase == DEFAULT_USE_CASE_NAME && (
        <CardGroup
          key={dgName}
          isAssistantAPILoading={isAssistantAPILoading}
          onCardClick={(title, key, confirmationMessage) => {
            handleSelectUseCase(title, key, confirmationMessage);
          }}
        />
      )}
      {isAssistantAPILoading && (
        <div className={styles.loadingContainer}>
          <div className={styles.loadingIcon}></div>
          <p>{LOADING_TEXT}</p>
        </div>
      )}
    </Stack>
  );
};

export default ChatLander;
